import SyncContainer from "./SyncContainer";

export default SyncContainer;
